<template>
  <div>
    <div class="banner">
      <div class="w flex" style="justify-content: space-between">
        <div class="ban_l">
          <a-input-search
            placeholder="请输入您要查询的服务..."
            enter-button="搜索"
            size="large"
            v-model.trim="keyword"
            @search="onSearch"
          />
        </div>
        <div class="ban_r"></div>
      </div>
    </div>
    <div class="w tabs flex">
      <div
        :class="['bon', index == tabIdx ? 'bon_cls' : '']"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabChange(index,item.link)"
      >
        {{ item.moduleName }}
      </div>
    </div>
    <div class="w desc">
      为您找到相关结果
      <span class="text_col">{{ allSearchNumber }}</span> 个，其中
      <span class="text_col" v-for="(item,index) in tabType" :key="index">「{{item.moduleName}}」{{ item.searchNumber }}个<span v-if="index!=tabType.length-1">、</span></span>
    </div>
    <!-- 模块内容 -->
    <div class="w">
      <div v-for="(item,index) in tabList" :key="index">
        <div v-if="item.link != ''&&item.ifBool&&item.searchNumber>0" class="tit_bar">{{ item.moduleName }}（{{ item.searchNumber }}）</div>
        <!-- 办事服务 -->
        <template v-if="item.link =='/serviceHall'&&item.ifBool">          
          <div class="service_box flex" v-for="item in serviceList" :key="item.serviceManageId">
            <img v-if="item.icon" :src="imgPrefix+item.icon" alt="">
            <img v-else src="../assets/index/icon-default.png" alt="" />
            <div style="flex: 7;">
              <div style="font-size: 18px;" v-html="showKeyWord(item.serviceManageName)"></div>
              <div style="display: flex;">
                <span style="flex: 1;">办理部门：{{item.departmentName}}</span>
                <span style="flex: 1;">服务主题：<span v-for="sub in item.serviceClassifyName" :key="sub">{{ sub }}&nbsp;&nbsp;</span></span>
                <span style="flex: 1;">服务对象：<span  v-for="item in item.targets" :key="item">{{ item }}&nbsp;&nbsp;</span></span>              
              </div>
            </div>
            <div style="flex: 2;" class="flex">
              <div class="bon_l" @click="gotogGide(item.serviceManageId)">查看详情</div>
              <div :class="[item.isApply==1?'bon_r':'disable_class']" @click="gotoWork(item.isApply,item.pcUrl)">{{item.isApply==1?'线上办理':'线下办理'}}</div>
            </div>
          </div>
          <a-pagination
            v-if="item.searchNumber>0"
            v-model="page"
            :defaultPageSize="5"
            :total="total"
            @change="pageChange($event,1)"
          />
        </template>
        <!-- 主题 -->
        <template v-if="item.link =='/theme'&&item.ifBool">
          <div style="margin: -1rem;padding-top: 16px;">
            <div class="w box_big clearfix">
              <div
                v-for="(item, index) in featureData"
                :key="index"
                style="margin: -1rem"
              >
                <div class="swiper_box fl" @click="checkDetails(item)">
                  <div class="hover">
                    <img :src="imgPrefix + item.card" alt="图片" />
                    <div class="swiper_con">
                      <div class="swiper_tit" style="margin-bottom: 12px" v-html="showKeyWord(item.name)"></div>
                      <div class="swiper_clamp" v-html="showKeyWord(item.introduction)"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>            
            <a-pagination
              v-if="item.searchNumber>0"
              v-model="page2"
              :defaultPageSize="4"
              :style="tabIdx==2?'margin-bottom: 60px;':''"
              :total="total2"
              @change="pageChange($event,2)"
            />
          </div>
        </template>  
        <!-- 公告 -->
        <template v-if="item.link == '/notice'&&item.ifBool">
          <div style="margin-bottom: 90px;">
            <div v-for="item in noticeData" :key="item.id" class="notice_box" @click="gotoDetails(item.id)">
              <div style="font-size: 18px;" v-html="showKeyWord(item.title)"></div>
              <div class="ntc_mi">发布时间：{{ item.publishTime }}&nbsp;&nbsp;发布单位：{{item.departmentName}}</div>
              <div v-html="showKeyWord(item.content)" class="nic_cnt"></div>
            </div>
            <a-pagination
              v-if="item.searchNumber>0"
              v-model="page3"
              :defaultPageSize="5"
              :total="total3"
              @change="pageChange($event,3)"
            />
          </div>
        </template>
      </div>
    
    </div>
    <!-- loading -->
    <a-spin v-if="loading" style="height: 200px;width: 100%;" />
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
import { format } from "../../utils/utils";
import { usageLogsApi,summarySearchModuleApi,findServiceManageByKeywordApi,findHomeThemeByKeywordApi,findHomeNoticeByKeywordApi } from "../api/index";
export default {
  data() {
    return {
      tabList: [],
      tabType:[],
      tabIdx: 0,
      code:'',
      imgPrefix,
      keyword: "",
      allSearchNumber: 0,
      serviceList:[],
      featureData:[],
      noticeData:[],
      page:1,
      page2:1,
      page3:1,
      pageSize:5,
      total:0,
      total2:0,
      total3:0,
      loading:false,
    };
  },
  created() {    
    this.keyword = sessionStorage.getItem('searchKeyWord');    
    this.getModuleNum(1)            
  },
  methods: {
    onSearch(e) {
      this.keyword = e;
      this.page=1;
      this.page2=1;
      this.page3=1;
      if(e){
        sessionStorage.setItem('searchKeyWord',e)
        this.serviceList = [];
        this.featureData = [];
        this.noticeData = [];
        this.getModuleNum(2)
      }else{
        this.$message.info('请输入关键字')
      }
    },
    tabChange(idx,link) {
      this.$forceUpdate();
      if(this.keyword){
        this.tabIdx = idx;
        this.link = link;
        this.getModuleNum(2)
      }else{
        this.$message.info('请输入关键字')
      }
    },
    // 查询各个模块数目
    getModuleNum(val){
      this.loading = true;
      summarySearchModuleApi({keyword:this.keyword}).then((res) => {
        // console.log(res);
        res.voList.forEach(item => {
          if(item.link == null){
            item.link = '/notice'
          }
        })
        this.tabType = res.voList;
        this.tabList = JSON.parse(JSON.stringify(res.voList));
        this.tabList.unshift({ moduleName: "全部", searchNumber: 0, link:'0' });
        this.allSearchNumber = res.allSearchNumber;

        this.tabList.forEach((item,index) => {
          if(val==1||this.tabIdx==0){
            item.ifBool = true;
          }else if(val==2&&index==this.tabIdx){
            item.ifBool = true;
          }
          // 存在对应模块，并且在'全部'或对应模块才请求接口
          if(item.link == '/serviceHall'&&(this.tabIdx==0||this.link==item.link)){
            this.getFindService();
          }else if(item.link == '/theme'&&(this.tabIdx==0||this.link==item.link)){
            this.getFindTheme();
          }
          else if(item.link == '/notice'&&(this.tabIdx==0||this.link==item.link)){
            this.getFindNotice()
          }
        })      
        this.loading = false;

        // console.log(this.tabList);
      }).catch(err => {
          this.$message.error(err.message)
          this.loading = false;
      });
    },
    // 查询服务大厅
    getFindService(){
      let dto = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword
      }
      findServiceManageByKeywordApi(dto).then(res => {       
        // res.voList.list.forEach(item => {
        //   item.targets = item.targets?.split(',')
        // });
        this.serviceList = res.voList.list;
        this.total = res.voList.total;

      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询主题
    getFindTheme(){
      let dto = {
        page: this.page2,
        pageSize: 4,
        keyword: this.keyword
      }
      findHomeThemeByKeywordApi(dto).then(res => {             
        this.featureData = res.pageListVo.list;
        this.total2 = res.pageListVo.total;

      }).catch(err => {
        this.$message.error(err.message)
      })
    },
      // 查询公告
    getFindNotice(){
      let dto = {
          page: this.page3,
          pageSize: this.pageSize,
          keyword: this.keyword
      }
      findHomeNoticeByKeywordApi(dto).then(res => {     
        // console.log(res);  
        res.pageListVo.list.forEach(item => {
          item.publishTime = format(item.createTime,"yyyy-MM-dd")
        })
        this.noticeData = res.pageListVo.list;
        this.total3 = res.pageListVo.total;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    showKeyWord(val) {
      var str = val;       
      let s = this.keyword;       
        //复制过来的数据中间带有空格的，去除中间空格，字符之间用逗号隔开       
      let inputvalue = s.replace(/\ +/g, ","); //把空格分开的字符串转换成以逗号分割       
      let keyWordArr2 = inputvalue.split(",");//把字符串转换成数组       
        // 当对话内容中有包含搜索框中的字符串时         
      if (str&& str!= ""&&this.keyword!='') {           
        keyWordArr2.forEach((e) => {             
          let regStr = "" + `(${e})`;             
          let reg = new RegExp(regStr, "g");             
          str = str.replace(reg,
            '<span style="color:red; font-weight: bold;">' + e + "</span>" );           
        });         
      }
      return str;     
    },
    // 查看指南
    gotogGide(id) {
      let dto = {
        "serviceId": id,
        "userId": "",
        }
        let userId = sessionStorage.getItem('userId');
        if(userId){
        dto.userId = userId;
        }
        usageLogsApi(dto).then(res => {})
        let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
        naviTop.forEach(item => {
          if(item.link == '/serviceHall'){
            this.$router.push("/serviceDetails?naviId=" + item.id + "&serviceManageId=" + id);      
          }
        });
    },
    gotoWork(isApply,url) {
      if(isApply){
        window.open(url);
      }
    },
    checkDetails(e) {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach(item => {
        if (item.link == "/theme") {
          this.$router.push("/themeDetails?themeId=" + e.id + "&naviId=" + item.id);
        }
      });
    },
    gotoDetails(id){
      this.$router.push('/noticeDetails?noticeId=' + id);
    },
    // 切换页码
    pageChange(page, val) {
      console.log(page, val);
      this.page = page;
      if(val == 1){
        this.getFindService()
      }else if(val == 2){
        this.getFindTheme();
      }else if(val == 3){
        this.getFindNotice()
      }
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 17rem;
  background: url("../assets/banner-red.png") no-repeat center;
  background-size: cover;
  text-align: left;
  margin-bottom: 28px;
  .ban_l {
    flex: 1;
    .tit {
      font-weight: 900;
      font-size: 40px;
      margin-bottom: 1%;
    }
    .desc {
      font-size: 18px;
      // color: #7a8ba4;
    }
  }
  .ban_r {
    width: 43%;
    height: 272px;
    background: url("../assets/banner-search-red.png") no-repeat right;
  }
}
.tit_bar{
  font-size: 20px;
  color: var(--themeColor);
  width: 100%;
  padding-bottom: 16px;
  margin-top: 58px;
  margin-bottom: 16px;
  border-bottom: 1px solid #E0E5F0;
  text-align: left;
  font-weight: 600;
}
.service_box{
  padding: 26px 0;
  border-bottom: 1px dashed #E0E5F0;
  text-align: left;
  font-size: 14px;
  width: 100%;
  span{
    color: #7A8BA4;
    margin-top: 12px;
    &:last-child{
      margin-right: 20px;
    }
  }
  img{
    width: 80px;
    // height: 80px;
    margin-right: 24px;
  }
}
.swiper_box {
    margin-right: 0;
    cursor: pointer;
    width: 25%;
    padding: 1rem;
    .hover {
      height: 16.625rem;
      transition: all 0.3s ease;
      box-shadow: 0px 3px 20px rgba(9, 41, 77, 0.1);
      // width: 278px;
    }
    img {
      width: 100%;
      height: 8.75rem;
    }
    .swiper_con {
      padding: 24px;
      text-align: left;
      .swiper_tit {
        font-size: 16px;
        color: #0d1c28;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .swiper_clamp {
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #7a8ba4;
        font-size: 14px;
      }
    }
  }
  .hover:hover {
    transition: all 0.3s ease;
    background: #1890ff;
    transform: translate3d(0, -0.3rem, 0);
    .swiper_tit,
    .swiper_clamp {
      color: #fff;
    }
  }

  /deep/.ant-btn-primary {
  background-color: var(--themeColor);
  border-color: var(--themeColor);
}
.notice_box{
  padding: 24px 0;
  margin-top: 16px;  
  text-align: left;
  border-bottom: 1px dashed #E0E5F0;
  cursor: pointer;
  .ntc_mi{
    color: #7A8BA4;
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: 14px;
  }
  .nic_cnt{
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden; // 溢出隐藏
    text-overflow: ellipsis; // 文字溢出显示省略号
    height: 20px;
  }
}
.text_col {
  color: var(--themeColor);
}
.tabs {
  border-radius: 8px;
  margin-top: 40px;
  margin-bottom: 24px;
  .bon {
    padding: 13px 30px;
    font-size: 18px;
    cursor: pointer;
    background: rgb(244, 246, 253);
    border-radius: 8px;
    margin-right: 32px;
    color: #7a8ba4;
  }
  .bon_cls {
    background: var(--themeColor);
    color: #fff;
  }
}
.bon_l {
  border: 1px solid var(--themeColor);
  border-radius: 8px;
  padding: 6px 8px;
  color: var(--themeColor);
  margin-right: 12px;
  cursor: pointer;
}
.bon_r {
  color: #fff;
  background: var(--themeColor);
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
}

/deep/.ant-input-group-wrapper {
  width: 100%;
}
.desc {
  text-align: left;
}
/deep/.ant-btn-lg {
  height: 56px;
  padding: 0 55px;
}
/deep/.ant-input-lg {
  height: 56px;
}
/deep/.ant-input-group .ant-input {
  border: none;
  box-shadow: none;
}
/deep/.ant-pagination{
  margin-top: 16px;
  text-align: right;
}
</style>
